// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2bOpP","itemTitle":"ClientEmergencyInfo_itemTitle__tGhDY","itemText":"ClientEmergencyInfo_itemText__1i0Dt"};